module.exports = __webpack_public_path__ + "static/media/head-side-headphones.ea546003.svg";